import {HttpClient, HttpErrorResponse, HttpEvent, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {Injectable} from '@angular/core';
import {catchError} from 'rxjs/operators';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';




@Injectable()
export class ApiService {

// baseUrl = 'https://pruebas2.egm-robotics.com';
  
baseUrl = environment.URL_API


  token = '' ;


  constructor(private http: HttpClient, private auth: AuthService) {
  }
  setToken(token){
    this.token = token;
  }
  getToken (){
    return this.token;
  }

  getPracticasUserUrl(path: string): string {
    return `${this.baseUrl}/api/practicas-user/${path}`;
  }


  autenticacion(parametros): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/practicas-autenticacion/login`, parametros)
      .pipe(catchError(this.handleError));
  }

  creacionCuenta(parametros): Observable<any> {
    return this.http.patch(`${this.baseUrl}/api/practicas-autenticacion/registro`, parametros)
      .pipe(catchError(this.handleError));
  }

  validacionCuenta(parametros: any, id: any, cdg: any): Observable<any> {
    return this.http.patch(`${this.baseUrl}/api/practicas-autenticacion/verificacionRegistro?e=${id}&cdg=${cdg}`, parametros)
      .pipe(catchError(this.handleError));
  }
  forgotPassword(parametros: any, ): Observable<any> {
    return this.http.patch(`${this.baseUrl}/api/practicas-autenticacion/forgotPassword`, parametros)
      .pipe(catchError(this.handleError));
  }
  reseteoCuenta(parametros: any, id: any, cdg: any): Observable<any> {
    return this.http.patch(`${this.baseUrl}/api/practicas-autenticacion/reseteoPassword?e=${id}&cdg=${cdg}`, parametros)
      .pipe(catchError(this.handleError));
  }


  // envioEmail(parametros): Observable<any> {
  //   return this.http.post(`${this.baseUrl}/api/servicios/envioEmail`, parametros)
  //     .pipe(catchError(this.handleError));
  // }
 
  
  getPostulaciones(): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/getPostulaciones`, {}, options)
      .pipe(catchError(this.handleError));
  }
  
  deletePostulacion(body: any): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/deleteForm`, body, options)
      .pipe(catchError(this.handleError));
  }

  newPostulacion(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/newPostulacion`, parametros, options)
      .pipe(catchError(this.handleError));
  }
  

  
  updateForm(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/updateForm`, parametros, options)
      .pipe(catchError(this.handleError));
  }
  updateFormByID(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/updateFormByID`, parametros, options)
      .pipe(catchError(this.handleError));
  }

  uploadFile(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/uploadFile`, parametros, options)
      .pipe(catchError(this.handleError));
  }
  

  uploadFileCategory(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/uploadFileCategory`, parametros, options)
      .pipe(catchError(this.handleError));
  }
  


  
  getForm(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/getForm`, parametros, options)
      .pipe(catchError(this.handleError));
  }

  getFormByid(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/getFormByID`, parametros, options)
      .pipe(catchError(this.handleError));
  }

  getForms(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/getListForms`, parametros, options)
      .pipe(catchError(this.handleError));
  }
  getFormStatus(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/getFormStatus`, parametros, options)
      .pipe(catchError(this.handleError));
  }

  getQuestionForms(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('getQuestionForms'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  getQuestionFormByID(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('getQuestionFormByID'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  upsertQuestionForm(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('upsertQuestionForm'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  deleteQuestionForm(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('deleteQuestionForm'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  getQuestionFormBuilder(parametros): Observable<any> {
    return this.http.patch(this.getPracticasUserUrl('getQuestionFormBuilder'), parametros)
      .pipe(catchError(this.handleError));
  }

  upsertQuestionFormElement(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('upsertQuestionFormElement'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  deleteQuestionFormElement(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('deleteQuestionFormElement'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  seedQuestionFormElements(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('seedQuestionFormElements'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  getPendingEmails(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('getPendingEmails'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  getPendingEmailsHistorial(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('getPendingEmailsHistorial'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  getPendingEmailOptions(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('getPendingEmailOptions'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  upsertPendingEmail(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('upsertPendingEmail'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  updatePendingEmailStatus(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('updatePendingEmailStatus'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  deletePendingEmail(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('deletePendingEmail'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  deleteAllPendingEmails(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('deleteAllPendingEmails'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  deleteAllPendingEmailsHistorial(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('deleteAllPendingEmailsHistorial'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  resendPendingEmail(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('resendPendingEmail'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  getFormStats(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('getFormStats'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  generarRecordatoriosAhora(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('generarRecordatoriosAhora'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  previsualizarRecordatorio(parametros = {}): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('previsualizarRecordatorio'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  getReminderConfig(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('getReminderConfig'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  updateReminderConfig(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('updateReminderConfig'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  getConfirmConfig(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('getConfirmConfig'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  updateConfirmConfig(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('updateConfirmConfig'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  generarConfirmacionesAhora(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('generarConfirmacionesAhora'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  previsualizarConfirmacion(parametros = {}): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('previsualizarConfirmacion'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  getConfirmStats(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(this.getPracticasUserUrl('getConfirmStats'), parametros, options)
      .pipe(catchError(this.handleError));
  }

  getDataForms(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/getUsersWithForm`, parametros, options)
      .pipe(catchError(this.handleError));
  }

  getDataDashboard(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/getDashboardData`, parametros, options)
      .pipe(catchError(this.handleError));
  }


  
  updateEval(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/updateEval`, parametros, options)
      .pipe(catchError(this.handleError));
  }
  
  getEvalByid(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/getEvalByID`, parametros, options)
      .pipe(catchError(this.handleError));
  }
  getCalificacionesById(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/getCalificacionesById`, parametros, options)
      .pipe(catchError(this.handleError));
  }

  guardarEvaluacionJuradoExperto(parametros): Observable<any> {
    const options = {
      headers: new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/guardarEvaluacionJuradoExperto`, parametros, options)
      .pipe(catchError(this.handleError));
  }

  getEvaluacionesJuradoExperto(parametros): Observable<any> {
    const options = {
      headers: new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/getEvaluacionesJuradoExperto`, parametros, options)
      .pipe(catchError(this.handleError));
  }
  


  getListUsers(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/getListUsers`, parametros, options)
      .pipe(catchError(this.handleError));
  }


  
  updateUser(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/updateUser`, parametros, options)
      .pipe(catchError(this.handleError));
  }


  
  newCategory(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/newCategory`, parametros, options)
      .pipe(catchError(this.handleError));
  }
  updateCategory(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/updateCategory`, parametros, options)
      .pipe(catchError(this.handleError));
  }


  



  getListCategorias(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/getListCategorias`, parametros, options)
      .pipe(catchError(this.handleError));
  }
  getListProvincias(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/getCatalog`, parametros, options)
      .pipe(catchError(this.handleError));
  }


  getListEntidades(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/getCatalogEntidades`, parametros, options)
      .pipe(catchError(this.handleError));
  }





  ////////////////////////////////////////////////////
  
  

  setStateProcess(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/setStateProcess`, parametros, options)
      .pipe(catchError(this.handleError));
  }


  getStateConfigGeneral(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/getStateConfigGeneral`, parametros, options)
      .pipe(catchError(this.handleError));
  }


  updateStateConfigGeneral(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/updateStateConfigGeneral`, parametros, options)
      .pipe(catchError(this.handleError));
  }



  
  



  // getGeoIP(parametros): Observable<any> {
  //   return this.http.post(`${this.baseUrl}/api/servicios/getGeoIP`, parametros)
  //     .pipe(catchError(this.handleError));
  // }



  // getIpAddress() {
  //   return this.http
  //     .get('https://api.ipify.org/?format=json')
  //     .pipe(
  //       catchError(this.handleError)
  //     );
  // }






////////////////////////////////////////////////////////////////////////////////////////////////////////



getRegistros(parameters): Observable<any> {

  return this.http.get(`${this.baseUrl}/api/dytron/getRegistros`, {params: parameters})
    .pipe(catchError(this.handleError));
}


newRegistro(parametros): Observable<any> {
  return this.http.post(`${this.baseUrl}/api/dytron/newRegistro`, parametros)
    .pipe(catchError(this.handleError));
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////


  nuevaNoticia(parametros): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/servicios/newNoticia`, parametros)
      .pipe(catchError(this.handleError));
  }

  getNoticias(): Observable<any> {
    console.log(`${this.baseUrl}/api/servicios/getNoticias`);
    return this.http.get(`${this.baseUrl}/api/servicios/getNoticias`)
      .pipe(catchError(this.handleError));
  }

  deleteNoticia(parametros): Observable<any> {
    const options = {
      headers: new HttpHeaders({}),
      body: parametros
    };
    return this.http.delete(`${this.baseUrl}/api/servicios/deleteNoticia`, options)
      .pipe(catchError(this.handleError));
  }

////////////////////////////////////////////////////////////////////////////////////////////////////////////




/////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // get url
  handleError(error: HttpErrorResponse) {
    console.log('error desconocido: ', error);
    // El cierre de sesión por token ausente, caducado o rechazado lo gestiona
    // AuthInterceptor, que limpia localStorage y saca al usuario a la portada.
    // Aquí solo se propaga el error para que cada pantalla lo muestre.
    return throwError(error.error);
  }

  guardarRespuestaPostulacion(datos: any) {
    return this.http.post(`${this.baseUrl}/api/postulacion/respuesta`, datos);
  }

  getDataUser(): Observable<any> {
    const options = {
      headers: new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/getDataUser`, {}, options)
      .pipe(catchError(this.handleError));
  }

  updateDataUser(parametros): Observable<any> {
    const options = {
      headers :  new HttpHeaders({['Authorization']: `Bearer ${this.auth.getToken()}`})
    };
    return this.http.patch(`${this.baseUrl}/api/practicas-user/updateDataUser`, parametros, options)
      .pipe(catchError(this.handleError));
  }

}
